import styled from 'styled-components'
import { TileCol } from 'Components/EnhacedFlexboxGrid'

export const _InsightCard = styled(TileCol)`
  padding: 0;
  margin-bottom: 10px;
  strong {
    font-weight: 700;
  }
  .prefix {
    line-height: 1;
    display: inline-block;
    transform: translateY(-12px) translateX(5px);
    color: #889398;
  }
  width: 49%;
  @media screen and (max-width: 1023px) {
    max-width: 100%;
    flex-basis: 100%;
    margin-bottom: 10px;
  }
`
